module.exports = __webpack_public_path__ + "img/backtoTop_icon.6042bdc.png";